import { get } from 'vuex-pathify';

export default {
  computed: {
    isUseDmaJunctionsDemandEnabledProxy: get('admin/settingsValues@epanet_dma_junctions_demand_enabled'),
    isEpanetDailyUsageEnabledProxy: get('admin/settingsValues@epanet_daily_usage_from_watermeters_attribute'),
  },
  methods: {
    getWaterModelingProfilePayload(profile) {
      const profileCopy = {
        net_kind: profile.net_kind,
        status: profile.status,
        features_filter: profile.features_filter,
        ...(profile.billing && {
          billing: profile.billing,
          billing_use_base_demand: profile.billing_use_base_demand,
          billing_demand_method: profile.billing_demand_method,
          ...(this.isEpanetDailyUsageEnabledProxy
            ? {
                watermeters_layer: profile.watermeters_layer,
                watermeters_daily_usage: profile.watermeters_daily_usage,
                watermeters_recipient_kind: profile.watermeters_recipient_kind,
              }
            : {
                billing_since: profile.billing_since,
                billing_until: profile.billing_until,
              }),
        }),
        ...(this.isUseDmaJunctionsDemandEnabledProxy &&
          profile.dma_layer && {
            dma_layer: profile.dma_layer,
            dma_pipes: profile.dma_pipes,
            dma_demand: profile.dma_demand,
          }),
      };
      return profileCopy;
    },
  },
};
